const dataAbout = [
    {
        id: 1,
        category: 'akun',
        title: 'Apa itu Tradiora?',
        text: 'Tradiora adalah platform trading all-in-one berbasis AI. Fitur meliputi AI analysis, edukasi trading, mentoring, komunitas trader, radar saham, dan trading journal.',
        show: 'show'
    },
    {
        id: 2,
        category: 'akun',
        title: 'Bagaimana cara memulai di Tradiora?',
        text: 'Daftar akun gratis, lengkapi profil, ikuti akademi trading, gunakan paper trading untuk berlatih, dan mulai trading dengan bantuan AI Assistant.',
    },
    {
        id: 3,
        category: 'trading',
        title: 'Aset apa saja yang bisa di-trading?',
        text: 'Tradiora mendukung trading saham dan crypto. Anda bisa trading berbagai aset seperti BTC, ETH, saham-saham unggulan, dan masih banyak lagi.',
    },
    {
        id: 4,
        category: 'akun',
        title: 'Apakah ada biaya untuk mendaftar?',
        text: 'Pendaftaran di Tradiora 100% gratis. Anda bisa langsung mengakses fitur dasar termasuk paper trading, akademi, dan bergabung dengan komunitas tanpa biaya.',
    },
    {
        id: 5,
        category: 'fitur',
        title: 'Apa itu AI Assistant di Tradiora?',
        text: 'AI Assistant adalah fitur analisis cerdas yang membantu Anda memahami pergerakan pasar, memberikan sinyal, dan menjawab pertanyaan seputar trading secara real-time.',
    },
    {
        id: 6,
        category: 'akun',
        title: 'Apakah Tradiora cocok untuk pemula?',
        text: 'Sangat cocok. Tradiora menyediakan Akademi Trading berupa materi edukasi terstruktur dari level pemula hingga mahir, serta paper trading untuk berlatih tanpa risiko modal.',
    },
    {
        id: 7,
        category: 'fitur',
        title: 'Apa itu paper trading?',
        text: 'Paper trading adalah fitur simulasi trading dengan saldo virtual. Anda dapat berlatih strategi dan memahami pasar tanpa menggunakan uang asli.',
    },
    {
        id: 8,
        category: 'fitur',
        title: 'Bagaimana cara menggunakan Radar Saham?',
        text: 'Radar Saham memindai pergerakan pasar dan menampilkan daftar saham atau crypto dengan potensi menarik berdasarkan analisis teknikal dan sentimen pasar.',
    },
    {
        id: 9,
        category: 'dukungan',
        title: 'Apakah data dan dana saya aman?',
        text: 'Tradiora mengutamakan keamanan dengan enkripsi data dan autentikasi yang aman. Untuk trading nyata, Anda terhubung dengan broker resmi sesuai regulasi yang berlaku.',
    },
    {
        id: 10,
        category: 'dukungan',
        title: 'Apakah saya bisa bergabung dengan komunitas trader?',
        text: 'Ya. Tradiora memiliki komunitas aktif di mana Anda bisa berdiskusi, berbagi strategi, dan mengikuti mentoring dari trader berpengalaman.',
    },
    {
        id: 11,
        category: 'fitur',
        title: 'Apakah Tradiora tersedia di perangkat mobile?',
        text: 'Ya. Tradiora dapat diakses melalui website dan juga tersedia dalam bentuk aplikasi mobile sehingga Anda bisa trading dan belajar di mana saja.',
    },
    {
        id: 12,
        category: 'trading',
        title: 'Apakah Tradiora memberikan jaminan profit?',
        text: 'Tidak. Trading memiliki risiko. Tradiora menyediakan alat bantu dan edukasi untuk membantu pengambilan keputusan, namun keputusan trading sepenuhnya menjadi tanggung jawab masing-masing pengguna.',
    },
    {
        id: 13,
        category: 'fitur',
        title: 'Apa itu Trading Journal di Tradiora?',
        text: 'Trading Journal mencatat seluruh aktivitas dan riwayat trading Anda, lengkap dengan analisis performa, sehingga Anda bisa mengevaluasi strategi dan memperbaikinya dari waktu ke waktu.',
    },
    {
        id: 14,
        category: 'fitur',
        title: 'Apakah saya bisa mengikuti mentoring satu-satu?',
        text: 'Ya. Tradiora menyediakan sesi mentoring dengan trader berpengalaman, baik dalam format kelompok maupun one-on-one, sesuai dengan paket keanggotaan Anda.',
    },
    {
        id: 15,
        category: 'dukungan',
        title: 'Bagaimana cara menghubungi tim Tradiora?',
        text: 'Anda dapat menghubungi kami melalui fitur live chat di aplikasi, email resmi, atau kanal media sosial Tradiora untuk bantuan dan pertanyaan lebih lanjut.',
    },
    {
        id: 16,
        category: 'trading',
        title: 'Apakah ada paket berlangganan premium?',
        text: 'Ya. Selain fitur gratis, Tradiora menawarkan paket premium dengan akses fitur lanjutan seperti analisis AI mendalam, mentoring eksklusif, dan sinyal trading tambahan.',
    },
    {
        id: 17,
        category: 'dukungan',
        title: 'Apakah Tradiora tersedia di negara saya?',
        text: 'Tradiora dapat diakses secara global melalui web dan mobile. Untuk fitur trading real yang terhubung dengan broker, ketersediaan dapat bervariasi tergantung regulasi di negara Anda.',
    },
    {
        id: 18,
        category: 'trading',
        title: 'Bagaimana cara menarik dana (withdraw)?',
        text: 'Untuk penarikan dana, Anda melakukan proses melalui broker yang terhubung dengan akun Tradiora Anda. Panduan lengkap tersedia di halaman bantuan atau melalui tim support kami.',
    },
    {
        id: 19,
        category: 'trading',
        title: 'Apa bedanya Tradiora dengan broker konvensional?',
        text: 'Tradiora bukan broker, melainkan platform all-in-one berbasis AI yang memadukan analisis, edukasi, mentoring, dan komunitas. Tradiora membantu Anda mengambil keputusan, sementara eksekusi trading dilakukan melalui broker terhubung.',
    },
    {
        id: 20,
        category: 'dukungan',
        title: 'Apakah ada program referral?',
        text: 'Ya. Tradiora memiliki program referral di mana Anda bisa mengundang teman dan mendapatkan reward atau potongan biaya premium sesuai dengan ketentuan program referral yang berlaku.',
    },
    {
        id: 21,
        category: 'akun',
        title: 'Bagaimana jika saya lupa password?',
        text: 'Anda dapat menggunakan fitur "Lupa Password" di halaman login untuk mereset kata sandi melalui email terdaftar. Jika mengalami kendala, hubungi tim support kami.',
    },
    {
        id: 22,
        category: 'akun',
        title: 'Apakah saya bisa menghapus akun saya?',
        text: 'Ya. Anda dapat mengajukan penghapusan akun melalui pengaturan akun atau dengan menghubungi tim support. Data Anda akan dihapus sesuai dengan kebijakan privasi Tradiora.',
    },

]

export default dataAbout;
